var React = require('react');

function CloseMini (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14","cy":"14","r":"12.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M14 15.4352L17.5648 19L19 17.5648L15.4352 14L19 10.4352L17.5648 9L14 12.5648L10.4352 9L9 10.4352L12.5648 14L9 17.5648L10.4352 19L14 15.4352Z","fill":"black","stroke":"black","key":1})]);
}

CloseMini.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = CloseMini;

CloseMini.default = CloseMini;
